module.exports = __webpack_public_path__ + "img/bjgd_white.85c123ee.png";